import { LuIcon, MenuV2 } from "@overmap-ai/blocks"
import { type ComponentPropsWithRef, memo } from "react"

import { HeadingLevel } from "../../enums"
import { headingDataMapping } from "../mappings"

export interface HeadingMenuGroupProps extends Omit<ComponentPropsWithRef<typeof MenuV2.Group>, "onSelect"> {
	levels: HeadingLevel[]
	onSelect: (level: HeadingLevel) => void
}

export const HeadingMenuGroup = memo<HeadingMenuGroupProps>((props) => {
	const { levels, onSelect, ...rest } = props

	return (
		<MenuV2.Group {...rest}>
			<MenuV2.GroupLabel>Headings</MenuV2.GroupLabel>
			{levels.map((level) => {
				const { label, icon } = headingDataMapping[level]
				return (
					<MenuV2.Item onSelect={() => onSelect(level)} key={level}>
						<LuIcon icon={icon} />
						{label}
					</MenuV2.Item>
				)
			})}
		</MenuV2.Group>
	)
})
HeadingMenuGroup.displayName = "HeadingMenuGroup"
